module.exports = __webpack_public_path__ + "static/media/interview.17cb39e4.png";